/*
 * @Author: linhao hao.lin@biz-united.com.cn
 * @Date: 2026-10-22 14:55:45
 * @LastEditors: linhao hao.lin@biz-united.com.cn
 * @LastEditTime: 2026-10-22 15:18:41
 * @FilePath: \crm-product\found\views\sfa\views\reports\display_fees\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import TablePage from '../../../../../components/table_page';
// import DatePicker from '../../../components/datePicker';
// import viewDetail from '../../../components/viewDetail.vue';
import Form from './form/index';

export default {
  name: 'table-component',
  extends: TablePage,
  components: {
    Form,
  },
  data() {
    return {
      // formName: 'viewDetail',
    };
  },
  methods: {
    beforeSearchEvent({
      $event,
    }) {
      if ($event.type === 'reset') {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        const executeStartTime = `${year}-${month}-${day} 00:00:00`;
        const executeEndTime = `${year}-${month}-${day} 23:59:59`;
        this.searchFormData = {
          ...this.searchFormData,
          executeStartTime,
          executeEndTime,
        };
        this.formData = {
          ...this.formData,
          executeStartTime,
          executeEndTime,
        };
      }
      return true;
    },
    modalClick({
      val,
      row,
    }) {
      const {
        code,
      } = val;
      if (code === 'view') {
        this.modalConfig.title = '详情';
        this.formName = 'Form';
        this.formConfig = {
          name: 'CLF',
          code,
          row,
        };
        this.openFull();
      }
    },
  },
  async created() {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    const executeStartTime = `${year}-${month}-${day} 00:00:00`;
    const executeEndTime = `${year}-${month}-${day} 23:59:59`;
    this.searchFormData = {
      ...this.searchFormData,
      executeStartTime,
      executeEndTime,
    };
    await this.getConfigList('display_fees_report');
    this.formData = {
      ...this.formData,
      executeStartTime,
      executeEndTime,
    };
  },

};
